import React, { useRef, useState } from 'react'
import {
  Flex, Popover, PopoverBody, PopoverCloseButton, PopoverContent, PopoverTrigger, Text,
  useDisclosure, Image, InputGroup, InputLeftElement, Input, Box, useToast,
  Grid, GridItem, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody
} from '@chakra-ui/react'
import MyDiv from './leaveBalance.style'
import { CustomButton, } from '../../../components'
import PlusIcon from '../../../assets/images/Vector.svg'
import { Search2Icon } from '@chakra-ui/icons'
import SortIcon from '../../../assets/images/SortIcon.svg'
import LeaveBalanceCard from '../components/LeaveBalanceCard/leaveBalanceCard'
import LeaveBalanceList from '../components/LeaveBalanceList'
import { ILazyParams, useFetch } from '../../../hooks/useFetch'
import ImportLeaveBalance from '../components/ImportLeaveBalance'

const sortOptions = [
  'Employee Name  (A–Z)',
  'Employee Name  (Z–A)',
  'Total Leave Balance (High–Low)',
  'Total Leave Balance (Low–High)',
];

const sortMapping: Record<string, { field: string; order: 1 | -1 }> = {
  'Employee Name  (A–Z)': { field: 'empName', order: 1 },
  'Employee Name  (Z–A)': { field: 'empName', order: -1 },
  'Total Leave Balance (High–Low)': { field: 'totalbalance', order: -1 },
  'Total Leave Balance (Low–High)': { field: 'totalbalance', order: 1 },
};

const LeaveBalance = (props: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isDrawerOpen, onOpen: onDrawerOpen, onClose: onDrawerClose } = useDisclosure();
  const [selected, setSelected] = useState<string>(sortOptions[0]);
  const [selectedLeave, setSelectedLeave] = useState(null);
  // Import popup state
  const [isImport, setIsImport] = useState(false);
  const toggleImport = () => setIsImport((prev) => !prev);
  const handleImportClose = () => setIsImport(false);
  // File upload state (single file only)
  const [step, setStep] = useState(1);
  const [file, setFile] = useState<any | null>(null);
  const toast = useToast();
  const searchRef = useRef<HTMLInputElement>(null);
  const [query, setQuery] = useState<{
    lazyParams: ILazyParams,
    filter: Record<string, number[]>,
    search?: string | null
  }>({
    lazyParams: { first: 0, rows: 20, page: 0, sortField: '', sortOrder: 1 },
    filter: {},
    search: null
  });

  const handleSelect = (option: string) => {
    setSelected(option);
    const sortConfig = sortMapping[option];
    if (sortConfig) {
        setQuery(prev => ({
          ...prev,
          lazyParams: {
            ...prev.lazyParams,
            sortField: sortConfig.field,
            sortOrder: sortConfig.order,
            page: 0,
            first: 0
          }
        }));
    };
    onClose();
  }

  const handleClickChange = (emp: any) => {
    setSelectedLeave(emp);
    onDrawerOpen();
  };

  // ---- File upload (single file only) ----
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const uploadedFile = e.target.files?.[0]; // only first file
    if (!uploadedFile) return;

    const sizeMB = uploadedFile.size / (1024 * 1024);
    if (sizeMB > 25) {
      toast({ title: "File too large.", description: `${uploadedFile.name} is over 25MB.`, status: "error", duration: 3000, isClosable: true, });
      return;
    }

    const newFile = {
      file: uploadedFile,
      name: uploadedFile.name,
      size: `${sizeMB.toFixed(1)} MB`,
      progress: 0,
    };

    setFile(newFile);
    setStep(2);

    // Simulate upload progress
    const interval = setInterval(() => {
      setFile((prev: any) => {
        if (!prev) return prev;
        if (prev.progress < 100) {
          return { ...prev, progress: prev.progress + 10 };
        } else {
          clearInterval(interval);
          return prev;
        }
      });
    }, 200);
  };

  const handleFile = (uploadedFile: File) => {
    const sizeMB = uploadedFile.size / (1024 * 1024);
    if (sizeMB > 25) {
      toast({ title: "File too large.", description: "The file size must be under 25MB.", status: "error", duration: 3000, isClosable: true, });
      return;
    }

    const newFile = {
      file: uploadedFile,
      name: uploadedFile.name,
      size: `${sizeMB.toFixed(1)} MB`,
      progress: 0,
    };

    setFile(newFile);
    setStep(2);

    const interval = setInterval(() => {
      setFile((prev: any) => {
        if (!prev) return prev;
        if (prev.progress < 100) {
          return { ...prev, progress: prev.progress + 10 };
        } else {
          clearInterval(interval);
          return prev;
        }
      });
    }, 200);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files?.[0];
    if (droppedFile) handleFile(droppedFile);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const resetImport = () => {
    setFile(null);
    setStep(1);
    setIsImport(false);
  };

  const handleSearch = (search: string) => {
    setQuery((prev) => ({
      ...prev,
      search: search.length > 0 ? search : null
    }));
  }

  return (
    <MyDiv>
      <Flex className="page_heading flex_header">
        <Text className="font-poppins text_semibold text_3xl">Leave Balance</Text>
        <Flex className="filter_section" gap={2}>
          {/* <InputGroup width="250px" height="25px">
            <InputLeftElement pointerEvents="none">
              <Search2Icon color="rgba(102, 112, 133, 1)" />
            </InputLeftElement>
            <Input type="text" onChange={(e) => handleSearch(e.target.value)} ref={searchRef} className="font-poppins text_regular text_md" placeholder="Search Employee by name...." />
          </InputGroup> */}

          {/* Sort dropdown */}
          {/* <Popover placement="bottom-end" closeOnBlur>
            <PopoverTrigger>
              <Image src={SortIcon} alt="Sort" className="icon_btn" />
            </PopoverTrigger>
            <PopoverContent w="270px" borderRadius="10px" boxShadow="md" textAlign={'center'}>
              <Box px={4} py={2} borderBottom="1px solid #eee">
                <Text className='font-poppins text_sm text_medium' textAlign="center" color={"#00000080"}>Sort By</Text>
                <PopoverCloseButton top="8px" right="12px" />
              </Box>
              <PopoverBody p={0}>
                {sortOptions.map((option) => (
                  <Box
                    key={option}
                    px={4}
                    py={2}
                    cursor="pointer"
                    bg={selected === option ? '#EBEBEB' : 'white'}
                    _hover={{ bg: '#EBEBEB' }}
                    onClick={() => handleSelect(option)}
                  >
                    <Text className='font-poppins font_dark' fontSize="14px" fontWeight="500" >
                      {option}
                    </Text>
                  </Box>
                ))}
              </PopoverBody>
            </PopoverContent>
          </Popover> */}
        </Flex>
      </Flex>

      {/* Employee Leave Balance List */}
      <Grid className='grid_container' mt={1}>
        <GridItem colSpan={12}>
          <LeaveBalanceList onView={handleClickChange} query={query} setQuery={setQuery} />
        </GridItem>
      </Grid>

      {/* Drawer for selected employee */}
      <Drawer isOpen={isDrawerOpen} placement="right" onClose={onDrawerClose} size="sm">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader borderBottomWidth="1px">Employee Leave Balance</DrawerHeader>
          <DrawerBody>
            <LeaveBalanceCard selectedLeave={selectedLeave} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </MyDiv>
  )                       
}

export default LeaveBalance;
